<template>
	<div>
		<div>
			<el-row :gutter="20">
				<el-col :xm="24" :md="12" :lg="14" style="margin-bottom:30px;">
					<!-- <div class="biaoqian">在线视频制作</div> -->
					<el-card class="box-card" style="border-radius:10px;" shadow="never">
						<div style="font-size: 14px;">
							<div class="biaoqian" style="padding-top: 0;">选择视频 (第一步)</div>
							<el-radio-group v-model="make_type" size="small">
								<el-radio-button label="链接上传"></el-radio-button>
								<el-radio-button label="视频上传"></el-radio-button>
							</el-radio-group>
							<div style="margin-top: 10px;" v-if="make_type == '链接上传'">
								<el-input type="textarea" v-model="allurl" :rows="8" placeholder="一行一个链接"
									@input="url_jc">
								</el-input>
								<div style="font-size: 12px;color: #888;display: flex;justify-content: end;">
									限制20条，已输入{{ spnum }}个视频</div>
							</div>
							<div style="margin-top: 10px;" v-if="make_type == '视频上传'" class="upload2">
								<!-- <el-upload class="upload-demo" drag action="#" ref="upload" :auto-upload="false"
									:limit="1" :before-upload="upload_fast"
									:file-list="videoFileList" :on-exceed="upload_xianzhi" :on-change="upload_change"
									:on-remove="upload_remove" :show-file-list="true" accept=".mp4,.mov" multiple>
									<i class="el-icon-upload"></i>
									<div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
									<div class="el-upload__tip" slot="tip">只能上传视频文件，且单个不超过200mb</div>
								</el-upload> -->
								<el-upload
									ref="upload"
									class="upload-demo"
									drag
									accept=".mp4,.mov"
									:before-upload="upload_fast"
									:on-exceed="upload_xianzhi"
									:on-remove="upload_remove"
									:action="upload_url"
									:on-success="onUploadVideoSuccess"
									:on-change="upload_change"
									:limit="15"
									multiple
								>
									<i class="el-icon-upload"></i>
									<div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
									<div class="el-upload__tip" slot="tip">最多20个文件  最多不超过300M</div>
								</el-upload>
							</div>
						</div>

						<div class="biaoqian" style="display: flex;align-items: center;">
							模式选择 (第二步)
							<span v-if="ms == 'N'" style="margin-left: 5px;color: #5280e9;text-decoration:underline;cursor: pointer;"
								@click="dingzhi_show = true">
								编辑
							</span>
						</div>
						<div style="">
							<el-radio-group v-model="ms" size="small" style="display: flex;flex-wrap: wrap;">
								<div v-for="(item, index) in ms_list" :key="index">
									<el-radio :label="item.url" border
										style="font-size: 12px;margin: 4px;width: 105px;position: relative;">
										{{ item.name }}
										<div style="position: absolute;top:-10px;right: -10px;background-color: rgb(206 43 43);color:#fff;padding: 5px;border-radius: 10px;transform: scale(0.8);"
											v-if="item.hot == 1">推荐</div>
									</el-radio>
								</div>
							</el-radio-group>
						</div>
						
						<div class="biaoqian">其他设置</div>
						<div>
							<el-checkbox-group v-model="ms_other_one" size="small"
								style="display: flex;flex-wrap: wrap;">
								<div v-for="(item, index) in ms_other" :key="index">
									<el-checkbox :label="item.url" border
										style="font-size: 12px;margin: 4px;width: 105px;">{{ item.name }}
									</el-checkbox>
								</div>
							</el-checkbox-group>
						</div>

						<div>
							<div class="biaoqian">裂变数量</div>
							<div style="display: flex;align-items: center;">
								<div style="font-size: 14px;margin-right: 10px;">
									单个视频制作数量:
								</div>
								<el-input-number v-model="xgcs" :min="1" :max="200" label="数量" size="mini"></el-input-number>
							</div>

						</div>
						<div style="margin-top:30px;">
							<!-- <el-row :gutter="10" style="">
                                <el-col :xs="24" :sm="12" style="margin-bottom: 10px;">
                                    <el-button @click="ks()" style="width:100%;" type="success"
                                        :loading="ksing">立即制作</el-button>
                                </el-col>
                                <el-col :xs="24" :sm="12">
                                    <el-button @click="ks('night')"
                                        style="width:100%;background-color: #3e40e3;color: #fff;" :loading="ksing"
                                        icon="el-icon-moon">预约第二天制作</el-button>
                                </el-col>
                            </el-row> -->
							<el-button @click="ks()" style="width:100%;" type="success" :loading="ksing">立即制作</el-button>
							<!-- <div  style="">
                                <el-link @click="ks('night')" style="text-align: center;margin-top: 13px;font-size: 0.8rem;color: #373adac7;" type="info"><i class="el-icon-moon" style="font-weight: 600;" ></i>预约第二天制作</el-link>
                            </div> -->
						</div>
					</el-card>
				</el-col>
				<el-col :xm="24" :md="12" :lg="10">
					<div class="biaoqian">制作记录</div>
					<el-card class="box-card" style="border-radius:10px;" shadow="never">
						<div style="font-size: 14px;">
							<!-- <div style="margin:10px 0px;">制作记录</div> -->
							<Record ref="Record"></Record>
						</div>
					</el-card>
				</el-col>
			</el-row>
		</div>

		<!-- <el-dialog :visible.sync="dingzhi_show" custom-class="newdialog_share">
			<Dingzhi></Dingzhi>
		</el-dialog> -->
	</div>
</template>

<script>
	import Record from "./record.vue";
	import { getBalance } from '@/config/api';
	// import Dingzhi from "@/components/Dingzhi.vue";
	export default {
		name: '',
		components: {
			Record,
			// Dingzhi
		},
		// 定义属性
		data() {
			return {
				allurl: '',
				ms_list: [],
				ms_other: [],
				ms: 'd',
				ms_other_one: [],
				videoFileList: [],
				spnum: 0,
				make_type: '链接上传',
				video_num: 0,
				ksing: false,
				dingzhi_show: false,
				xgcs: 1,
				upload_fq: [],
				urload_url:'',
				uploading: false,
			}
		},
		// 计算属性，会监听依赖属性值随之变化
		computed: {},
		// 监控data中的数据变化
		watch: {},
		// 方法集合
		methods: {
			onUploadVideoSuccess(response, file, fileList){
				console.log(fileList,'onUploadVideoSuccess')
				this.videoFileList = fileList
			},
			upload_remove(file, fileList) {
				console.log(fileList,'upload_remove')
				const index = fileList.indexOf(file);
				fileList.splice(index, 1);
				this.video_num = fileList.length
				this.videoFileList = fileList
			},
			upload_change(file, fileList) {
				// this.videoFileList = []
				this.video_num = fileList.length
				// this.videoFileList.push(file);
				// console.log(this.videoFileList,'upload_change')
			},
			upload_xianzhi(files, fileList) {
				this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			},
			upload_fast(file) {
				console.log(file)
				if (file.type == 'video/mp4' || file.type == 'video/quicktime') {
				} else {
					this.$message.error('上传视频只能是 mp4或mov 格式!');
					return false
				}
				const isLt2M = file.size / 1024 / 1024 < 300;
				if (!isLt2M) {
					this.$message.error('上传视频大小不能超过 300MB!');
					return false
				}
				return true;
			},
			url_jc() {
				this.spnum = this.allurl.split('\n').length
				this.video = []
			},
			get_ms() {
				var httpData = {}
				this.$http.post("/api/video/index",httpData).then(res => {
					this.ms_list = res.msList
					this.ms_other = res.msList2
				})
			},
			async ks(appointed = '') {
				var ms = this.ms + this.ms_other_one.join("")
				if (this.make_type == '视频上传') {
					if (this.videoFileList.length==0) {
						this.$message('请上传要制作的视频');
						return
					}
					var urlArr = []
					this.videoFileList.forEach((item)=>{
						if(item.response.code==1){
							urlArr.push(item.response.data.url)
						}
					})
					var httpData = {
						url: urlArr.join(','),
						type:0,
						ms:ms,
						num:this.xgcs
					}
					this.$http.post("/api/video/addVideo",httpData,{timeout: 30000}).then(res => {
						this.videoFileList = []
						this.$refs.upload.clearFiles();
						getBalance()
						this.$refs.Record.fy_page(1)
						this.$message({
							 message: '制作成功',
							 type: 'success'
						});
					})
				} else {
					//链接上传
					if (this.allurl == '') {
						this.$message('请填写要制作的视频');
						return
					}
					if (this.spnum > 20) {
						this.$message.error('非独立用户一次性只能提交20个链接');
						return
					}
					var httpData = {
						url: this.spnum>1?this.allurl.split('\n').join(','):this.allurl,
						type:1,
						ms:ms,
						num:this.xgcs,
					}
					this.$http.post("/api/video/addVideo",httpData).then(res => {
						this.$message({
							 message: '制作成功',
							 type: 'success'
						});
						this.allurl = ''
						getBalance()
						this.$refs.Record.fy_page(1)
					})
				}
			},
		},
		// 生命周期 - 创建完成（可以访问当前this实例）
		created() {
			var BASE_URL = '';
			var url = location.href;
			var arr = url.split('/'); //图片域名
			if(arr[2]) {
				BASE_URL = arr[0]+'//'+arr[2];
			}
			this.upload_url = BASE_URL+'/api/video/uploadVideo';
		},
		// 生命周期 - 挂载完成（可以访问DOM元素）
		mounted() {
			this.get_ms()
			// this.common.ismobile(this)
		},
		beforeCreate() {}, // 生命周期 - 创建之前
		beforeMount() {}, // 生命周期 - 挂载之前
		beforeUpdate() {}, // 生命周期 - 更新之前
		updated() {}, // 生命周期 - 更新之后
		beforeDestroy() {}, // 生命周期 - 销毁之前
		destroyed() {}, // 生命周期 - 销毁完成
		activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
	}
</script>

<style>
	.upload2 .el-upload {
		width: 100%;
	}

	.upload2 .el-upload-dragger {
		width: 100%;
	}
</style>